const menuRight =
	"<span style='float:right' class='webix_icon action-menu wxi-dots'></span>";

const menuClose =
	"<span style='float:right' class='webix_icon action-close wxi-close'></span>";

export { menuRight, menuClose };
